import { LockKeyhole, ShieldAlert } from "lucide-react";

import { useProfessionalAuth } from "../auth/ProfessionalAuthContext";
import "../styles/shell.css";

export default function AccessDeniedPage() {
  const { user } = useProfessionalAuth();

  return (
    <main className="shell-page">
      <section className="shell-hero-card">
        <div className="shell-hero-icon shell-hero-icon-warning">
          <ShieldAlert size={22} />
        </div>
        <div className="shell-hero-copy">
          <span className="shell-eyebrow">Acceso limitado</span>
          <h1>Tu cuenta no tiene secciones habilitadas</h1>
          <p>
            Has iniciado sesión correctamente en <strong>{user?.tenantName || "el negocio seleccionado"}</strong>,
            pero ahora mismo no tienes permisos activos para acceder a ninguna sección de la app.
          </p>
        </div>
      </section>

      <section className="shell-placeholder-panel">
        <div className="shell-placeholder-header">
          <LockKeyhole size={18} />
          <span>Qué hacer ahora</span>
        </div>
        <p>
          Pide a un administrador del negocio que te asigne permisos desde el panel de administración. En cuanto se
          actualicen, bastará con volver a iniciar sesión para entrar en las secciones autorizadas.
        </p>
      </section>
    </main>
  );
}
